// PostHog, or nothing at all.
//
// No relay proxy here — that exists in Zoomaa to dodge ad blockers, which needs its own
// backend route and a second host split (assets vs. ingestion). This app talks to PostHog
// directly; add the relay later only if blocked traffic turns out to be a real problem here.
//
// Without a key every function below is a no-op: a build with no key configured runs exactly
// as it does with one.
const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

let loading = null;

export function startAnalytics() {
  if (loading || !KEY) return loading;

  loading = import('posthog-js')
    .then(({ default: posthog }) => {
      posthog.init(KEY, {
        api_host: HOST,
        capture_pageview: true,
        // The id also lives in a cookie on .tigaly.ai, which tigaly.ai's own PostHog sets, so a
        // visitor's landing-page visits and their sign-up here are one person.
        persistence: 'localStorage+cookie',
        cross_subdomain_cookie: true,
      });
      return posthog;
    })
    .catch(() => null);

  return loading;
}

const withPostHog = use => {
  if (!loading) return;
  loading.then(posthog => posthog && use(posthog));
};

export const identify = user => {
  if (!user?.id) return;
  withPostHog(posthog => posthog.identify(String(user.id), { email: user.email, name: user.fullName }));
};

export const forget = () => withPostHog(posthog => posthog.reset());

export const track = (event, properties) => withPostHog(posthog => posthog.capture(event, properties));
